import Vue from 'vue'
import { watch, onDeactivated } from '@vue/composition-api'
import { stateDefault, state } from '..'
import handleValueOrFunction from '@iez/lib/handle-value-or-function/'

export default payload => {
  const set = payload => {
    if (!payload) {
      set(stateDefault)
    } else {
      Object.entries(payload)
        .forEach(([name, value]) => {
          Vue.set(state, name, value)
        })
    }
  }
  handleValueOrFunction({
    valueOrFunction: payload,
    callback: payload => {
      set(payload)
    }
  })
}
